import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {Amplify} from "aws-amplify";
import AwsConfig from './aws-exports';
import reportWebVitals from './reportWebVitals';

Amplify.configure(AwsConfig);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
